const DEFAULT_REDIRECT_URL = '/profiles';

const isSafeRelativePath = (candidate: string): boolean => {
	if (!candidate.startsWith('/')) {
		return false;
	}

	if (candidate.startsWith('//')) {
		return false;
	}

	return true;
};

export const getSafeRedirectUrl = (redirectParam: string | string[] | undefined): string => {
	const candidate = Array.isArray(redirectParam) ? redirectParam[0] : redirectParam;

	if (typeof candidate !== 'string') {
		return DEFAULT_REDIRECT_URL;
	}

	const trimmed = candidate.trim();

	if (!trimmed) {
		return DEFAULT_REDIRECT_URL;
	}

	if (!isSafeRelativePath(trimmed)) {
		return DEFAULT_REDIRECT_URL;
	}

	return trimmed;
};

export const getDefaultRedirectUrl = (): string => DEFAULT_REDIRECT_URL;
